/* Ott-common */
import {
  string,
  number,
  objectOf,
  arrayOf,
  shape,
  date,
  boolean,
} from '@dtvgo/typed-normalizr';

export const Entity = {
  id: string(),
  resourceType: string(),
  sourceProvider: string(),
};

export const WithPictureId = {
  pictureId: string(),
};

export const Named = {
  name: string(),
  shortName: string(),
};

export const Described = {
  description: string(),
  shortDescription: string(),
};

export const Playable = {
  assetId: string(),
};

export const WithMetadata = {
  metadata: shape({
    id: string(),
    source: string(),
    status: string(),
  }),
};

export const WithReleaseYear = {
  releaseYear: number(),
};

export const SportsContent = {
  sportName: string(),
  leagueName: string(),
  tournamentName: string(),
};

export const LiveContent = {
  stationId: string(),
  stationName: string(),
  startTime: date(),
  endTime: date(),
  blackout: boolean(),
};

export const WithSeasonNumber = {
  seasonNumber: number(),
};

export const WithPictures = {
  pictures: objectOf(string()),
};

export const WithGenres = {
  genres: arrayOf(shape({
    id: string(),
    name: string(),
  })),
};

export const WithDuration = {
  duration: number(),
};

export const WithRating = {
  rating: string(),
  ratingAdvisories: arrayOf(string()),
};

export const WithLabels = {
  labels: arrayOf(string()),
};

export const WithShowableData = {
  ...Entity,
  ...Named,
  ...Described,
  ...WithPictureId,
  ...WithReleaseYear,
  ...WithPictures,
  ...WithGenres,
  ...WithRating,
  ...WithLabels,
};

export const Content = {
  ...WithShowableData,
  ...WithMetadata,
  ...WithDuration,
  qualifiers: arrayOf(string()),
};

export const Competition = {
  ...Content,
  ...SportsContent,
  primaryPersonName: string(),
  primaryPersonPictureId: string(),
  secondaryPersonName: string(),
  secondaryPersonPictureId: string(),
};

export const TeamCompetition = {
  ...Content,
  ...SportsContent,
  primaryTeamName: string(),
  primaryTeamPictureId: string(),
  secondaryTeamName: string(),
  secondaryTeamPictureId: string(),
};

export const Episode = {
  ...Content,
  ...WithSeasonNumber,
  episodeNumber: number(),
  showId: string(),
  showName: string(),
  seasonId: string(),
};

export const MergedContent = {
  ...Content,
  ...Competition,
  ...TeamCompetition,
  ...Episode,
};

const WithPrimaryAndBackupURLs = {
  primary: string(),
  backup: string(),
};

export const URLsObject = {
  dash: shape(WithPrimaryAndBackupURLs),
  hls: shape(WithPrimaryAndBackupURLs),
};
